import { Profile } from "@/features/account/profile";

export const Route = createFileRoute({
  component: Profile,
});
